document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("has-transparent-header")) return;

  const header = document.querySelector(".header-wrapper");
  const contentContainers = document.querySelectorAll(".multicolumn , .rich-text ");

  if (!header || contentContainers.length === 0) return;

  function updateHeader() {
    let sectionReached = false;

    contentContainers.forEach(section => {
      const rect = section.getBoundingClientRect();

      // Section reached: top touches viewport & still visible
      if (rect.top <= 0 && rect.bottom > 0) {
        sectionReached = true;
      }
    });

    // Toggle header class
    if (sectionReached) {
      header.classList.add("header-black");
    } else {
      header.classList.remove("header-black");
    }
  }

  // Scroll listener
  window.addEventListener("scroll", updateHeader);

  // Initial check
  updateHeader();
});

// Run when DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  // Use querySelector in case ID exists
  const bar = document.querySelector('#header-info-bar');

  if (!bar) {
    
    return;
  }



  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > lastScroll && currentScroll > 50) {
     
      bar.classList.add('is-hidden');
    } else if (currentScroll < lastScroll) {
      

    }

    lastScroll = currentScroll;
  });
});

// document.addEventListener('DOMContentLoaded', () => {
//   const header = document.querySelector('.header-wrapper'); // Sticky header
//   const topBar = document.querySelector('#header-info-bar'); // Announcement bar
//   const main = document.querySelector('main');

//   if (!main) return; // Only proceed if main exists

//   let totalHeight = 0;

//   if (header) totalHeight += header.offsetHeight; // Add header height if exists
//   if (topBar) totalHeight += topBar.offsetHeight; // Add announcement bar height if exists

//   if (totalHeight > 0) {
//     main.style.marginTop = `${totalHeight}px`; // Apply only if any exists
//   }
// });
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');
  if (!header) return;

  const headerHeight = header.offsetHeight;
  const body = document.body;

  window.addEventListener('scroll', () => {
    if (window.scrollY > headerHeight) {
      body.classList.add('body-scrolled-past-header');
    } else {
      body.classList.remove('body-scrolled-past-header');
    }
  });
});

// Set dynamic viewport height variable in :root
function setViewportSizeFull() {
  const vhFull = screen.height * 0.01;
  const vwFull = screen.width * 0.01;
  document.documentElement.style.setProperty('--vh-full', `${vhFull}px`);
  document.documentElement.style.setProperty('--vw-full', `${vwFull}px`);
}
setViewportSizeFull();
window.addEventListener('resize', setViewportSizeFull);
window.addEventListener('orientationchange', setViewportSizeFull);